<template>
  <v-col :cols="cols">
    <span>{{ title }}</span>
    <quill-editor ref="myQuillEditor" :content="content" :options="options" :loading="loading || $async.upload.$pending"
      :disabled="disabled" :class="getErrorClass" @input="trim($event)" @change="onEditorChange($event)" />
    <ErrorMessage v-if="isShowErrorMessage" :message="errorText" />
  </v-col>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import toolbarOptions from '@/configs/quillEditorToolbarOptions'
import toolbarOptionsLight from '@/configs/quillEditorToolbarOptionsLight'

import Quill from 'quill'
import ImageUploader from 'quill-image-uploader'

import ErrorMessage from '@/components/error-messages/ErrorMessage'

import uploadFileMutation from '@/services/gql/types/Files/mutations/uploadFile.gql'

Quill.register('modules/ImageUploader', ImageUploader)

export default {
  name: 'QuillEditorVue',
  components: {
    ErrorMessage
  },
  props: {
    cols: {
      type: Number,
      default: 12
    },
    title: {
      type: String,
      default: 'Полное описание'
    },
    content: {
      type: String,
      default: ''
    },
    contentForMobile: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isShowErrorMessage: {
      type: Boolean,
      default: false
    },
    errorText: {
      type: [String, Array],
      default: ''
    },
    lightMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      options: {
        modules: {
          ...this.optionsToolbar,
          ImageUploader: {
            upload: async file => {
              try {
                const item = await this.$async.upload.$perform({
                  data: { file, mediaLibrary: true }
                })
                return item.data.upload.url
              } catch (e) {
                this.$handleApiError(e.graphQLErrors, 'Ошибка при загрузке файла')
              }
            }
          }
        },
        placeholder: 'Начните вводить здесь...'
      }
    }
  },
  computed: {
    optionsToolbar () {
      return this.lightMode ? toolbarOptionsLight : toolbarOptions
    },
    isDark () {
      return this.$deepModel('ui.general')?.darkTheme || false
    },
    getErrorClass () {
      return this.errorText?.length ? 'red' : ''
    }
  },
  watch: {
    isDark (newVal) {
      if (newVal) {
        Object.values(document.querySelectorAll('span.ql-header.ql-picker')).forEach(
          elem => (elem.style.color = 'rgba(255, 255, 255, 0.7)')
        )
        Object.values(document.querySelectorAll('.ql-snow .ql-stroke')).forEach(
          elem => (elem.style.stroke = 'rgba(255, 255, 255, 0.7)')
        )
        Object.values(document.querySelectorAll('.ql-picker-options')).forEach(
          elem => (elem.style.backgroundColor = '#000')
        )
        document.documentElement.style.setProperty(
          '--placeholder-color',
          'rgba(255, 255, 255, 0.7)'
        )
      } else {
        Object.values(document.querySelectorAll('span.ql-header.ql-picker')).forEach(
          elem => (elem.style.color = 'rgba(0, 0, 0, 0.6)')
        )
        Object.values(document.querySelectorAll('.ql-snow .ql-stroke')).forEach(
          elem => (elem.style.stroke = '#444')
        )
        Object.values(document.querySelectorAll('.ql-picker-options')).forEach(
          elem => (elem.style.backgroundColor = '#FFF')
        )
        document.documentElement.style.setProperty('--placeholder-color', '#444')
      }
    }
  },
  methods: {
    trim (html) {
      document.createRange().createContextualFragment(html).textContent.trim() === ''
        ? this.$emit('input', '')
        : this.$emit('input', html)
    },
    onEditorChange ({ quill }) {
      this.$emit('onChangeContent', quill.getText().replace(/\n/g, ''))
    }
  },
  async: {
    upload (variables) {
      return this.$apollo.mutate({
        mutation: uploadFileMutation,
        variables
      })
    }
  },
  mounted () {
    document.documentElement.style.setProperty(
      '--placeholder-color',
      this.isDark ? 'rgba(255, 255, 255, 0.7)' : '#444'
    )
    Object.values(document.querySelectorAll('.ql-picker-options')).forEach(
      elem => (elem.style.backgroundColor = this.isDark ? '#000' : '#FFF')
    )
  }
}
</script>
<style>
:root {
  --placeholder-color: rgba(255, 255, 255, 0.7);
}

.ql-editor.ql-blank::before {
  color: var(--placeholder-color);
}
</style>
